/**
 * defa.views.RecipientPhoneCreateForm
 * A Form for creating phone recipients.
 * @version 1.0.0
 */

import { defa } from '../../../defa-object';
import Form     from '../../poppet/form';
import template from '../notifications/template-recipient-phone-create-form.jst.html';

const selectors = {
	inputPhoneNumber         : '[data-input=recipient-phone-number]',
	inputSmsEmergencyAlerts  : '[data-input=recipient-sms-emergency-alerts]',
};

export const RecipientPhoneCreateForm = Form.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	template,
	noInitValidation: true,
	ui: {
		inputPhoneNumber         : selectors.inputPhoneNumber,
		inputSmsEmergencyAlerts  : selectors.inputSmsEmergencyAlerts,
	},
	events: {
		'click @ui.inputSmsEmergencyAlerts' : 'onClickInputSmsEmergencyAlerts'
	},

	
	templateContext: function(){
		return{
			phoneNumber : this.model.get('recipient') || '',
			generalLevel : this.model.get('generalLevel') || '',
		}
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Triggers when the view renders.
	 * @void
	 */
	onRender: function(){
		this.initPhoneNumber();
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	initPhoneNumber: function(){
		// setup our country variables
		let country   = defa.objects.languageSettings.country,
			countries = [ 'no', 'se', 'dk', 'fi', ];
		
		// add country to the top of the array and remove duplicates
		countries.unshift( country );
		countries = _.uniq( countries );
		
		// setup numbers
		this.ui.inputPhoneNumber.intlTelInput( {
			preferredCountries: countries,
			utilsScript       : '/assets/vendor/intl-tel-input-utils.min.js',
			autoPlaceholder   : 'off',
			separateDialCode  : true,
		} );
	},

	
	/**
	 * Validates the number input field
	 * Triggers when the user inputs something into the input field.
	 * @void
	 */
	validate: function(){
		let currentNumber = this.ui.inputPhoneNumber.val().trim();
		return currentNumber !== ''
	},
	
	/**
	 * Triggers when a user clicks the save button.
	 * Submits the form.
	 * @void
	 */
	submit() {
		let prefix    = '+' + this.ui.inputPhoneNumber.intlTelInput( 'getSelectedCountryData' ).dialCode.trim(),
			number    = prefix + this.ui.inputPhoneNumber.intlTelInput( 'getNumber' ).replace( prefix, '' ).trim();
		let form = {
			recipient        : number,
			emergencyLevel   : this.ui.inputSmsEmergencyAlerts.is( ':checked' ),
			generalLevel     : false,
			
		};
		this.model.set(form);
		this.savePhoneRecipient();

	},
	
	/**
	 * Saves a recipient model to backend.
	 * @void
	 */
	savePhoneRecipient:function(){
		let self = this;
		self.busy();
		try {
			self.model.save( {}, {
				success: function () {
					console.log( 'Recipient Model was saved!' );
					self.idle();
					self.trigger('close', self);
					
				},
				error  : function () {
					alert( 'failed syncing' );
					console.error( 'Recipient Model failed at saving...' );
					self.idle();
				}
			} );
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
			self.model.revertModel();
		}
	},
} );
export default RecipientPhoneCreateForm;